<div class="wrapper">
  <div class="container-fluid">

    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript: void(0);" routerLink="/management/client">Client</a></li>
              <li class="breadcrumb-item active">{{heading}}</li>
            </ol>
          </div>
          <h4 class="page-title">{{heading}}</h4>
        </div>
      </div>
    </div>

    <!-- end page title -->

    <div class="row" *ngIf="clientViewModel">
      <div class="col-12">

        <div class="card-box">
          <h4 class="header-title">Client Details</h4>
          <div class="row">
            <div class="col-12">
              <div>
                <form class="form-horizontal" role="form" autocomplete="off">
                  <div class="form-group row">
                    <label class="col-2 col-form-label">Client Name</label>
                    <div class="col-10">
                      <input [(ngModel)]="clientViewModel.name" [ngModelOptions]="{standalone: true}" type="text" class="form-control" placeholder="Client Name" (change)="validateClientName()">
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-2 col-form-label">Client Participant</label>
                    <div class="col-10">
                      <ng-select2 [(ngModel)]="selectedParticipants" [ngModelOptions]="{standalone: true}" [data]="participants" [options]="select2options"></ng-select2>
                    </div>
                  </div>

                  <div class="form-group row" offset-3 col-9 *ngIf="error">
                    <div class="col-10">
                      <p class="text-danger">{{errorMessage}}</p>
                    </div>
                  </div>

                  <div class="form-group row" *ngIf="id">
                    <label class="col-2 col-form-label">API Key</label>

                    <div class="col-10">
                      <div class="input-group">
                        <input [(ngModel)]="keyName" [ngModelOptions]="{standalone: true}" type="text" class="form-control" placeholder="API Key Name" aria-label="API Key Name" aria-describedby="basic-addon2">
                        <div class="input-group-append">
                          <button class="btn btn-info waves-effect waves-light" type="button" (click)="addNewApiKey()">Add API Key <i class="mdi mdi-key-plus"></i></button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <ng-container>
                    <div class="form-group row" *ngFor="let key of clientViewModel.apiKeys">
                      <div class="offset-2 col-10">
                        <div class="input-group">
                          <input type="text" class="form-control" [value]="key.name" disabled>
                          <div class="input-group-append">
                            <button (click)="deleteApiKey(key)" class="btn btn-warning waves-effect waves-light" type="button"><i class="mdi mdi-delete-forever"></i></button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>

                  <button (click)="save()" *ngIf="canAddEdit" class="btn btn-info waves-effect waves-light fa-pull-right" type="button">Save <i class="mdi mdi-content-save"></i></button>

                </form>
              </div>
            </div>

          </div>
        </div>

      </div>

    </div>

  </div> <!-- end container -->
</div>
